export default __webpack_public_path__ + "static/media/Datenschutz.a65d8b80.png";